// extracted by mini-css-extract-plugin
module.exports = {"filters":"nWzbNd","categoryPage":"MRb2tB","filterList":"mBt5OQ"};